export const LOADING_COMPANY_RESPONSIBLE = "LOADING_COMPANY_RESPONSIBLE";
export const SAVE_LOADING_COMPANY_RESPONSIBLE = "SAVE_LOADING_COMPANY_RESPONSIBLE";
export const GET_COMPANY_RESPONSIBLE = "GET_COMPANY_RESPONSIBLE";
export const FORM_FAIL = "FORM_FAIL";
export const COMPANY_RESPONSIBLE_FAIL = "COMPANY_RESPONSIBLE_FAIL";
export const LOADING_COMPANY_RESPONSIBLE_BY_ID = "LOADING_COMPANY_RESPONSIBLE_BY_ID";
export const GET_COMPANY_RESPONSIBLE_BY_ID = "GET_COMPANY_RESPONSIBLE_BY_ID";
export const GET_COMPANY_RESPONSIBLE_SELECTS = "GET_COMPANY_RESPONSIBLE_SELECTS"